/* eslint-disable no-param-reassign */

xplenty.directive('selectEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./select-editor.html'),

      replace: true,

      link(scope, element, attrs) {
        scope.onRecordsChange = (records) => {
          scope.component.fields = records;
        };
      },
    };
  },
]);
